import { FlexAligner, Mode as ThemeMode } from '@scaleaq/scaleui';
import { Moon, SunIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { ChipsItem } from '@/components/chips/chips.types.ts';
import { SegmentedChips } from '@/components/chips/SegmentedChips.tsx';
import { LanguageSelector } from '@/components/LanguageSelector.tsx';
import { useUserSettings } from '@/hooks';
import { Icon, responsive } from '@/utils';

export const SettingsPreferences = () => {
  const { t } = useTranslation();
  const { theme, setTheme } = useUserSettings();

  const themeItems: ChipsItem<ThemeMode>[] = [
    { id: 'dark', value: 'dark', label: 'Dark', headIcon: <Moon size={16} /> },
    { id: 'light', value: 'light', label: 'Light', headIcon: <SunIcon size={16} /> },
    {
      id: 'auto',
      value: 'auto',
      label: t('system', 'System'),
      headIcon: <Icon.Settings />,
    },
  ];
  const selectedTheme = themeItems.find(opt => opt.value === theme) ?? themeItems[0];

  return (
    <FlexAligner direction='column' gap={responsive.spacing['2xlarge']}>
      <LanguageSelector label={t('language')} />
      <SegmentedChips
        label={t('theme')}
        size='small'
        items={themeItems}
        value={selectedTheme}
        onChange={item => item.value && setTheme(item.value)}
      />
    </FlexAligner>
  );
};
